import type {ImageDetails} from "@vesta/janus-compatibility-module/utilities/typeDefinitions";
import intellsysDarkModeLogoUrl from "~/svgs/intellsysHeaderLogo.svg?url";
import IntellsysHeaderLogoLightTheme from "~/svgs/intellsysHeaderLogoDark.svg?url";
import IntellsysHeaderLogoDarkTheme from "~/svgs/intellsysHeaderLogo.svg?url";

export const HEIMDALL_LOCAL_STORAGE_KEY = "heimdall";

/**
 * @deprecated Use intellsysLogo_wordmark_lightTheme or intellsysLogo_wordmark_darkTheme instead
 */
export const intellsysLogo: ImageDetails = {
    width: 1714,
    height: 487,
    variants: [
        {
            width: 1714,
            height: 487,
            url: intellsysDarkModeLogoUrl,
            format: "svg",
            fileSize: 0,
        },
    ],
};

export const intellsysLogo_wordmark_lightTheme: ImageDetails = {
    width: 124,
    height: 28,
    variants: [
        {
            width: 124,
            height: 28,
            url: IntellsysHeaderLogoLightTheme,
            format: "svg",
            fileSize: 0,
        },
    ],
};

export const intellsysLogo_wordmark_darkTheme: ImageDetails = {
    width: 124,
    height: 29,
    variants: [
        {
            width: 124,
            height: 29,
            url: IntellsysHeaderLogoDarkTheme,
            format: "svg",
            fileSize: 0,
        },
    ],
};
